class NewsletterPopupComponent extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'naturflow-newsletter-popup-dismissed';
  }

  connectedCallback() {
    const overlay = this.querySelector('[data-popup-overlay]');
    const closeBtn = this.querySelector('[data-popup-close]');
    const form = this.querySelector('form');

    const alreadyDismissed = this.getCookie(this.cookieName);
    const submittedSuccessfully = this.querySelector('.newsletter-popup__success');

    if (submittedSuccessfully) {
      this.show();
      this.setCookie(this.cookieName, '1', 365);
    } else if (!alreadyDismissed) {
      const delay = parseInt(this.dataset.delay || '5000', 10);
      this.timer = setTimeout(() => this.show(), delay);
    }

    const dismiss = () => {
      this.hide();
      const days = parseInt(this.dataset.cookieDays || '14', 10);
      this.setCookie(this.cookieName, '1', days);
    };

    overlay && overlay.addEventListener('click', dismiss);
    closeBtn && closeBtn.addEventListener('click', dismiss);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-visible')) {
        dismiss();
      }
    });
  }

  show() {
    this.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    const input = this.querySelector('input[type="email"]');
    if (input) setTimeout(() => input.focus(), 350);
  }

  hide() {
    this.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
}

customElements.define('newsletter-popup-component', NewsletterPopupComponent);
